import Button from "../components/button";
import CheckboxDefault from "../components/checkbox";
import FormTextArea from "../components/field/textArea";
import FormHead from "../components/headings/FromHead";
import Styles from "./styles.module.scss";
import Modal from "../components/modal";
import { FormInput } from "../wrappers/formInput";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { FormAreaInput } from "../wrappers/formArea";
import { useEffect, useState } from "react";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import MultiSelectDropdown from "../components/multiSelect";
import { MultiDropDownInput } from "../wrappers/multiselectInput";
import * as CONSTANTS from "../utils/CONSTANTS";
import * as SKILLS from "../utils/Skill";
import {
  EditorState,
  convertToRaw,
  convertFromRaw,
  Modifier,
  ContentState,
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { convertToHTML } from "draft-convert";
import htmlToDraft from "html-to-draftjs";
import { skillNameConverter } from "../utils/EllowUtils";

export type ProjectFormFields = {
  name: string;
  companyName: string;
  doneFor: string;
  contribution: string;
  skills: any;
  link: string;
};

interface Props {
  ClickHandler: any;
  onClose: any;
  defaultValues: {
    name: string;
    companyName: string;
    doneFor: string;
    contribution: string;
    skills: { text: string; id: number }[];
    link: string;
  };
  skillsList: any;
}
const validationSchema = Yup.object({
  name: Yup.string().required("Field is required"),
  // companyName: Yup.string().required("Field is required"),
  // doneFor: Yup.string().required("Field is required").nullable(true),
  // skills: Yup.object()
  // // .required('This field is required.')
  // .shape({
  //   skillId: Yup.number(),
  //   skillName: Yup.string()}),

  link: Yup.string()
    .transform((currentValue, originalValue) => {
      return originalValue === "" ? null : currentValue;
    })
    .nullable(true)
    .matches(
      /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
      "Please provide a valid link"
    ),
});

const ProjectForm: React.FC<Props> = ({
  ClickHandler,
  onClose,
  defaultValues,
  skillsList
}) => {
  const formOptions = {
    resolver: yupResolver(validationSchema),
  };

  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm<ProjectFormFields>(formOptions);

  useEffect(() => {
    if (defaultValues)
      if (defaultValues.contribution) {
        if (defaultValues.contribution.includes('{"blocks')) {
          let oldblockconverteddata = convertFromRaw(
            JSON.parse(defaultValues.contribution)
          );
          let oldblockdataconvertedhtml = convertToHTML(oldblockconverteddata);

          defaultValues.contribution = JSON.stringify(
            oldblockdataconvertedhtml
          );
        }
        setValue("contribution", defaultValues.contribution);
        // setEditorState(EditorState.createWithContent(convertFromRaw(JSON.parse(defaultValues.summary))));
        const contentState = editorState.getCurrentContent();
        if (
          JSON.stringify(convertToRaw(contentState)) !==
          defaultValues.contribution
        ) {
          try {
            setEditorState(
              EditorState.createWithContent(
                convertFromRaw(JSON.parse(defaultValues.contribution))
              )
            );
          } catch (e) {
            // setEditorState(
            //   EditorState.createWithContent(
            //     ContentState.createFromText(defaultValues.contribution)
            //   )
            // );
            let contributiondata = defaultValues && defaultValues.contribution;
            let convertdata = contributiondata.includes("<p>");
            let olconvertdata = contributiondata.includes("<ol");
            let ulconvertdata = contributiondata.includes("<ul>");
            if (convertdata || olconvertdata || ulconvertdata) {
              const blocksFromHTML = htmlToDraft(JSON.parse(contributiondata));
              const updateblockstate = ContentState.createFromBlockArray(
                blocksFromHTML.contentBlocks,
                blocksFromHTML.entityMap
              );
              setEditorState(EditorState.createWithContent(updateblockstate));
            } else {
              const blocksFromHTML = htmlToDraft(contributiondata);
              const updateblockstate = ContentState.createFromBlockArray(
                blocksFromHTML.contentBlocks,
                blocksFromHTML.entityMap
              );
              setEditorState(EditorState.createWithContent(updateblockstate));
            }
            // var contributiondata = JSON.parse(defaultValues.contribution);

            // const blocksFromHTML = htmlToDraft(contributiondata);
            // const updateblockstate = ContentState.createFromBlockArray(
            //   blocksFromHTML.contentBlocks,
            //   blocksFromHTML.entityMap
            // );
            // setEditorState(EditorState.createWithContent(updateblockstate));
          }
        }
      }

    reset(defaultValues);
  }, [defaultValues]);

  const [editorState, setEditorState] = useState<any>(
    EditorState.createEmpty()
  );
  const [disable, setDisable] = useState(false);

  const onclose = () => {
    onClose();
  };

  const onSubmit = (data: any) => {
    setDisable(true);
    data.action = defaultValues ? "update" : "add";
    ClickHandler(data);
  };
  const handleChange = (e: any, name: any) => {
    setValue(name, e.target.value);
  };

  const onEditorStateChange = (state: any) => {
    setEditorState(state);
    const contentState = state.getCurrentContent();
    let currentContentAsHTML = convertToHTML(contentState);
    setValue("contribution", JSON.stringify(currentContentAsHTML));
    // setValue("contribution", JSON.stringify(convertToRaw(contentState)));
  };

  return (
    <div className={Styles.detailsCard}>
      <FormHead>Project</FormHead>
      <div className="form-group">
        <FormInput<ProjectFormFields>
          id="name"
          type="text"
          name="name"
          // defaultValue={defaultValues.name ? defaultValues.name : ''}
          label="Project Name*"
          placeholder=""
          register={register}
          errors={errors}
        />
      </div>
      <div className="half-form-wrap mb-0">
        <div className="form-group">
          <FormInput<ProjectFormFields>
            id="companyname"
            type="text"
            name="companyName"
            label="Company Name"
            placeholder=""
            // defaultValue={defaultValues.companyName ? defaultValues.companyName : ''}
            register={register}
            errors={errors}
          />
        </div>
        <div className="form-group">
          <FormInput<ProjectFormFields>
            id="doneFor"
            type="text"
            name="doneFor"
            label="Project is done for"
            // defaultValue={defaultValues.doneFor ? defaultValues.doneFor : ''}
            placeholder=""
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="form-group">
        <label className="lablel">Your contribution</label>
        {/* <FormAreaInput<ProjectFormFields>
                  id="contribution"
                  name="contribution"
                  placeholder=""
                  register={register}
                  value={defaultValues.contribution ? defaultValues.contribution : ''}
                  errors={errors}
                  onchange={(e: any) => handleChange(e, 'contribution')}>
                 </FormAreaInput> */}
        <Editor
          editorState={editorState}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editorClassName"
          onEditorStateChange={onEditorStateChange}
        />
      </div>
      <div className="form-group">
        {/* <FormInput<ProjectFormFields>
                  id="skills"
                  type="text"
                  name="skills"
                  register={register}
                  errors={errors}
                  label="Skills used in this project*"
                  placeholder=""
                /> */}

        <MultiDropDownInput<ProjectFormFields>
          data={skillsList && skillsList.length > 0 && skillNameConverter(skillsList)}
          textField="skillName"
          // data={testValue}
          disabled={false}
          label={"Skills used in this project"}
          name="skills"
          register={register}
          // defaultValue={defaultValues.skills ? defaultValues.skills : [{}]}
          errors={errors}
          onChange={(e: any) => handleChange(e, "skills")}
          control={control}
          dataItemKey="skillId"
          allowCustom={false}
        />
      </div>
      <div className="form-group">
        <FormInput<ProjectFormFields>
          id="link"
          type="text"
          name="link"
          register={register}
          errors={errors}
          label="External link to the projects"
          placeholder=""
        />
      </div>

      <div className={Styles.popupAction}>
        <Button
          onClick={onclose}
          type="submit"
          variant="secondary"
          size="small"
        >
          Cancel
        </Button>
        <Button
          disabled={disable}
          onClick={handleSubmit(onSubmit)}
          type="submit"
          variant="primary"
          size="small"
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default ProjectForm;
